import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CatalogProduct } from '../../core/models';
import { toCatalogCategory } from '../../core/utils/catalog-map.util';
import { CatalogState } from './catalog.reducer';

export const selectCatalogState = createFeatureSelector<CatalogState>('catalog');

export const selectFilters = createSelector(selectCatalogState, (s) => s.filters);
export const selectActiveId = createSelector(selectCatalogState, (s) => s.activeId);

/** Raw category+products payload from the smartAsset store API. */
export const selectApiCategories = createSelector(selectCatalogState, (s) => s.categories);
export const selectCatalogCategoriesLoading = createSelector(
  selectCatalogState,
  (s) => s.categoriesLoading,
);
export const selectCatalogCategoriesLoaded = createSelector(
  selectCatalogState,
  (s) => s.categoriesLoaded,
);
export const selectCatalogCategoriesError = createSelector(
  selectCatalogState,
  (s) => s.categoriesError,
);

/** Flattened, render-ready categories (each with its own products). */
export const selectCatalogCategories = createSelector(selectApiCategories, (categories) =>
  categories.map(toCatalogCategory),
);

/** Every live product across all categories, as a flat list. */
export const selectAllCatalogProducts = createSelector(
  selectCatalogCategories,
  (categories): CatalogProduct[] => categories.flatMap((c) => c.products),
);

